module.exports = __webpack_public_path__ + "static/img/banner_3.b0e38090.png";